import { WarningCircle } from 'phosphor-react'

import { DialogModal } from '../../../../../components/DialogModal'
import { Button } from '../../../../../components/Button'
import { formatDate } from '../../../../../utils/date'
import { type TaskCommentDomain } from '../../../../../types/domain/task-comment-domain'

type DeleteCommentModalProps = {
  isRemoving: boolean
  commentToDelete?: TaskCommentDomain | null
  isOpen: boolean
  onClose: () => void
  onDelete: () => void
}

export const DeleteCommentModal = ({
  isRemoving,
  commentToDelete,
  isOpen,
  onClose,
  onDelete,
}: DeleteCommentModalProps) => {
  if (!commentToDelete) {
    return null
  }

  return (
    <DialogModal isOpen={isOpen} onClose={onClose}>
      <div className="px-8 py-6">
        <WarningCircle size={72} className="mx-auto mb-10 text-primary-light" />

        <p className="mb-6">Deseja mesmo excluir esse comentário?</p>

        <div className="p-4 border rounded-lg border-grey-500">
          <div className="w-full">
            <strong className="text-sm font-bold text-grey-800">
              {commentToDelete.author.name}:
            </strong>

            <div className="pr-4 overflow-y-auto max-h-36 scrollbar">
              <p className="my-2 text-sm break-words text-grey-800">
                {commentToDelete.content}
              </p>
            </div>

            <time className="text-xs text-grey-700">
              {formatDate(new Date(commentToDelete.createdAt), {
                dateStyle: 'short',
                timeStyle: 'short',
              })}
            </time>
          </div>
        </div>

        <div className="flex gap-2 mt-14">
          <Button
            size="large"
            variant="outline"
            className="flex-1"
            onClick={onClose}
          >
            Cancelar
          </Button>
          <Button
            onClick={onDelete}
            isLoading={isRemoving}
            size="large"
            className="flex-1"
          >
            Excluir
          </Button>
        </div>
      </div>
    </DialogModal>
  )
}
